<template>
  <PComponentLoader :loading="loading">
    <div v-if="!loading">
      <CContainer class="pt-4">
        <template v-if="visibleFeatureKeys.length > 0">
          <component
            v-for="featureKey in visibleFeatureKeys"
            :key="featureKey"
            :ref="featureKey"
            :is="getFeatureComponent(featureKey)"
            :config="getFeatureConfig(featureKey)"
            :pica-service-id="eventId"
          />
        </template>

        <div v-else class="text-center py-5">
          <CIcon name="cil-puzzle" size="3xl" class="text-muted mb-3" />
          <p class="text-muted" v-translate translate-context="features.step">
            No features available for this event.
          </p>
        </div>
      </CContainer>

      <div class="d-flex justify-content-end p-3 border-top" v-if="visibleFeatureKeys.length > 0">
        <CButton color="success" variant="outline" @click="onReset" class="mr-2">
          <translate translate-context="event_wizard">Reset</translate>
        </CButton>
        <PButton color="primary" @click="onSave">
          <translate translate-context="event_wizard">Save</translate>
        </PButton>
      </div>
    </div>
  </PComponentLoader>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PComponentLoader from '@/domain/core/components/PComponentLoader.vue'
import PButton from '@/components/PButton.vue'
import FEATURE_COMPONENTS from '@/domain/picaServiceFeatures/features'
import { getFeaturePermission } from '@/domain/picaServiceFeatures/constants'

export default {
  name: 'StepFeatures',
  components: {
    PComponentLoader,
    PButton,
    ...FEATURE_COMPONENTS
  },
  computed: {
    ...mapGetters('eventWizard', ['eventId']),
    ...mapGetters('login', ['hasPerm']),
    ...mapGetters('picaServiceFeatures', [
      'loading',
      'getFeatureConfig'
    ]),
    /**
     * Feature keys visible to the user based on permissions.
     * Uses permissions from pica_service config instead of backend response.
     */
    visibleFeatureKeys() {
      const allFeatureKeys = Object.keys(FEATURE_COMPONENTS)
      return allFeatureKeys.filter(featureKey =>
        this.hasPerm(getFeaturePermission(featureKey))
      )
    }
  },
  async mounted() {
    await this.initFeatures()
  },
  methods: {
    ...mapActions('picaServiceFeatures', [
      'setPicaServiceId',
      'fetchFeatures',
      'updateFeatures'
    ]),
    async initFeatures() {
      this.setPicaServiceId(this.eventId)
      await this.fetchFeatures()
    },
    getFeatureComponent(featureKey) {
      return FEATURE_COMPONENTS[featureKey] || null
    },
    collectFeaturesData() {
      const data = {}
      for (const featureKey of this.visibleFeatureKeys) {
        const ref = this.$refs[featureKey]
        if (ref && ref[0] && typeof ref[0].getConfig === 'function') {
          data[featureKey] = ref[0].getConfig()
        }
      }
      return data
    },
    onReset() {
      for (const featureKey of this.visibleFeatureKeys) {
        const ref = this.$refs[featureKey]
        if (ref && ref[0] && typeof ref[0].reset === 'function') {
          ref[0].reset()
        }
      }
    },
    async onSave() {
      const data = this.collectFeaturesData()
      await this.updateFeatures(data)
      await this.notifySuccess(this.$pgettext('features.step', 'Features updated'))
    }
  }
}
</script>
